function homePageLoaded() {

	var introVideo = jQuery('iframe#intro-video')[0];
	var videoContainer = jQuery('.video-fullscreen');
	var closeVideoIcon = jQuery('.video-fullscreen .close-item');

	jQuery(window).load(function() {
		loading_screen.finish();
	});

	jQuery('#play-intro-video').on('click', playIntroVideo);
	closeVideoIcon.on('click', closeIntroVideo);

	var homepageVideo = jQuery(jQuery("iframe.background-video")[0]);
	homepageVideo.on("play", function(event, data) {
		videoLoaded = true;
	});

	var videosLoadingTimeout = setTimeout(function() {
		if (!videoLoaded) { hideVideos(homepageVideo, {fadeOut: true}); }
	}, maxTimeForLoad);

	function playIntroVideo(event){

		if (videoContainer.hasClass('fadeOut')) {

			videoContainer.removeClass('fadeOut').addClass('fadeIn');
		} else {

			videoContainer.addClass('animated fadeIn');
		}
		jQuery(introVideo).vimeo("play");
	}

	function closeIntroVideo(event){

		videoContainer.removeClass('fadeIn').addClass('fadeOut');
		jQuery(introVideo).vimeo("pause");
		jQuery(introVideo).vimeo("seekTo", 0);
	}
	jQuery(introVideo).on('finish', closeIntroVideo);
}
